import React from 'react';
import PropTypes from 'prop-types';
import { isObject } from 'lodash';
import { Field } from 'redux-form';
import FormDatepicker from '../../components/form/FormDatepicker/FormDatepicker';

const parseDate = value => isObject(value) ? value.format('DD/MM/YYYY') : value;

const FormDatepickerContainer = props =>
  <Field
    name={props.name}
    component={FormDatepicker}
    parse={parseDate}
    props={props}
  />
;

FormDatepickerContainer.propTypes = {
  name: PropTypes.string
};

export default FormDatepickerContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/FormDatepickerContainer.js
 **/